/**
 * Ryan O'Dowd
 * 2018-02-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, isDarkMode, safeAreaInsets, windowWidth, windowWidthRaw}) => {
  const prevNextWidth = 50; // @TODO: don't hardcode...base on threshold
  const prevNextBase = {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: prevNextWidth,
    height: '100%',
    position: 'absolute',
  };

  let innerWrapperHorizontalPadding = 0;
  if (Platform.OS === 'web' && ((windowWidth + (2 * prevNextWidth)) > windowWidthRaw)) {
    innerWrapperHorizontalPadding = prevNextWidth;
  }

  return {
    innerContainer: {
      flex: 1,
      alignItems: 'center',
      width: '100%',
      marginBottom: safeAreaInsets.bottom,
    },
    prev: {
      ...prevNextBase,
      left: innerWrapperHorizontalPadding ? 0 : -prevNextWidth,
    },
    next: {
      ...prevNextBase,
      right: innerWrapperHorizontalPadding ? 0 : -prevNextWidth,
    },
    pageIcon: {
      fontSize: 24,
      color: colors.white,
    },
    pageIconPrev: {
      marginLeft: 16,
    },
    pageIconNext: {
      marginRight: 16,
    },

    innerWrapper: {
      flex: 1,
      width: '100%',
      height: '100%',
      paddingRight: innerWrapperHorizontalPadding,
      paddingLeft: innerWrapperHorizontalPadding,
    },

    verseWrapperContainerOuter: {
      backgroundColor: `${isDarkMode ? colors.primaryDark : colors.primary}88`,
    },
    verseWrapperContainer: {
      minHeight: '100%',
    },

    // @TODO: abstract these with components/PassageDisplay/Verse/styles.native.js
    verseWrapper: { // @TODO: common
      padding: 8,
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 6,
      borderLeftWidth: 4,
      borderRightWidth: 4,
      borderLeftColor: 'transparent',
      borderRightColor: 'transparent',
    },
    demoVerseWrapper: {
      marginBottom: 8,
    },
    selectedVerseWrapper: {
      borderLeftColor: colors.qqq,
    },
    selectedVerseText: {
      textDecorationLine: 'underline',
      color: colors.qqq,
    },
    typedVerse: {
      fontSize: globalScale * 16, // @TODO: toggleable
      color: colors.white,
      opacity: 1,
    },
    highlightedVerseWrapper: {
      borderLeftColor: colors.inContextHightlight,
    },
    highlightedVerseText: {
      color: colors.inContextHightlight,
    },
    completedVerseWrapper: {
      borderRightColor: colors.accent,
    },
    completedVerseText: {
      color: colors.accent,
    },
    inProgressVerseWrapper: {
      borderRightColor: colors.complete,
    },
    inProgressVerseText: {
      color: colors.complete,
    },
    unstartedVerseWrapper: {
      borderRightColor: colors.lightGray,
    },
    unstartedVerseText: {
      color: colors.lightGray,
    },
    labelWrapper: {
      display: 'flex',
      position: 'absolute',
      width: '50%',
      bottom: 64,
      transform: [{rotate: '-90deg'}],
    },
    chapterLabel: {
      display: 'flex',
      alignSelf: 'flex-start',
      width: 500,
      fontSize: 24,
      color: colors.white,
    },

    legendWrapper: {
      backgroundColor: colors.primary,
      padding: globalScale * 8,
      borderRadius: globalScale * 16,
      borderColor: colors.primaryLight,
      borderWidth: globalScale * 4,
    },
    dialogText: {
      fontSize: globalScale * 16,
      color: isDarkMode ? colors.white : colors.black,
      marginTop: globalScale * 8,
      marginBottom: globalScale * 16,
    },
    selectedMenuItem: {
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
